import { Injectable } from '@angular/core';
import {
  Float32BufferAttribute,
  Uint16BufferAttribute,
  Uint32BufferAttribute,
  Uint8BufferAttribute,
} from 'three';
import { getInstanceIdsValues } from './segmentation-mask-utils';
import {
  getIntensityValues,
  getPointPositionsValues,
  getSourceIdValues,
} from './spc-parsing-utils';

export interface CloudAttributes {
  position: Float32BufferAttribute;
  instanceId: Uint32BufferAttribute;
  sourceId?: Uint8BufferAttribute;
  intensity?: Uint16BufferAttribute;
}

export interface AccumulatedGroundAttributes {
  position: Float32BufferAttribute;
  intensity?: Uint16BufferAttribute;
}

@Injectable({ providedIn: 'root' })
export class CloudAttributesService {
  build(asset: ArrayBuffer, segmentationMaskContent: ArrayBuffer) {
    const pointBufferAttributes: CloudAttributes = {
      position: getPointPositionsValues(asset),
      intensity: getIntensityValues(asset),
      instanceId: getInstanceIdsValues(segmentationMaskContent),
      sourceId: getSourceIdValues(asset),
    };
    return pointBufferAttributes;
  }

  buildAccumulatedGround(asset: ArrayBuffer) {
    const accumulatedBufferAttributes: AccumulatedGroundAttributes = {
      position: getPointPositionsValues(asset),
      intensity: getIntensityValues(asset),
    };
    return accumulatedBufferAttributes;
  }
}
